import { computed } from "vue";
import useCreateComponentConfig from "../../../../composables/useCreateComponentConfig.js";
import { SIZES } from "@/ui/ts/types/Sizes";
var EStepperSeperatorElements = /* @__PURE__ */ ((EStepperSeperatorElements2) => {
  EStepperSeperatorElements2["ROOT"] = "root";
  EStepperSeperatorElements2["SVG"] = "svg";
  return EStepperSeperatorElements2;
})(EStepperSeperatorElements || {});
export function useStepperSeperatorConfig(props) {
  const { rootClasses } = useRootConfig(props);
  const { SVGClasses } = useSVGConfig(props);
  return {
    root: rootClasses,
    SVG: SVGClasses
  };
}
function useRootConfig(props) {
  const { setBase, addSize, getClasses } = useCreateComponentConfig();
  setBase(
    "root" /* ROOT */,
    props.orientation === "horizontal" ? (
      /* tw */
      "min-w-sm w-full"
    ) : "min-h-sm h-full"
  );
  addSize(
    "root" /* ROOT */,
    SIZES.SMALL,
    props.orientation === "horizontal" ? (
      /* tw */
      "separator absolute left-[calc(50%+(var(--size-units-6)-1px)/2)] top-[calc(50%-var(--border-width-border)/2)]"
    ) : (
      /* tw */
      ""
    )
  );
  addSize(
    "root" /* ROOT */,
    SIZES.MEDIUM,
    props.orientation === "horizontal" ? (
      /* tw */
      "px-2"
    ) : (
      /* tw */
      "py-1.5"
    )
  );
  const rootClasses = computed(() => getClasses("root" /* ROOT */, void 0, props.size));
  return {
    rootClasses: rootClasses.value
  };
}
function useSVGConfig(props) {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase("svg" /* SVG */, props.orientation === "horizontal" ? (
    /* tw */
    "w-full"
  ) : "h-full");
  const SVGClasses = computed(() => getClasses("svg" /* SVG */));
  return {
    SVGClasses: SVGClasses.value
  };
}
